import React from "react";
import {API} from "../../api";
import {API_CALL} from "../../types";
import {isError, isLoading, isSuccess, showErrorsInToast, translateError} from "../../common";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Form76EmployeeEditModal} from "./Form76EmployeeEditModal";
import {ConfirmModal} from "../common/ConfirmModal";
import {Division} from "./Form76Divisions";

interface Form76EmployeesProps {
}

interface Form76EmployeesState {
    loading: boolean,
    addEmployee: boolean,
    deleteEmployee: Employee|null,
    editEmployee: Employee|null,
    employees: Employee[];
}

export interface Employee {
    id: number;
    division_id: number;
    name: string;
    rate: number;
    division: Division;
}

export class Form76Employees extends React.Component<Form76EmployeesProps, Form76EmployeesState> {

    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            addEmployee: false,
            deleteEmployee: null,
            editEmployee: null,
            employees: [],
        }

        this.loadReport = this.loadReport.bind(this);
        this.editEmployee = this.editEmployee.bind(this);
        this.deleteEmployee = this.deleteEmployee.bind(this);
        this.saveEmployee = this.saveEmployee.bind(this);
    }

    componentDidMount() {
        this.loadReport();
    }

    loadReport() {
        API.getForm76Employees(
            (apiCall: API_CALL) => {
                this.setState({loading: isLoading(apiCall)});

                if (isError(apiCall)) showErrorsInToast(apiCall, 'Грешка', translateError);

                if (isSuccess(apiCall)) {
                    this.setState({employees: apiCall.data.data.employees, addEmployee: false, editEmployee: null});
                }
            }
        );
    }

    editEmployee(d: Employee) {
        this.setState({editEmployee: d})
    }

    deleteEmployee(d: Employee) {
        this.setState({deleteEmployee: d})
    }

    doDeleteEmployee(btn: string) {
        this.setState({deleteEmployee: null});
        if(btn === "Изтрий") 
        API.deleteForm76Employee(
            (apiCall: API_CALL) => {
                this.setState({loading: isLoading(apiCall)});

                if (isError(apiCall)) showErrorsInToast(apiCall, 'Грешка', translateError);

                if (isSuccess(apiCall)) {
                    this.loadReport()
                }
            }, this.state.deleteEmployee as Employee)
    }

    saveEmployee(d: Employee) {
        this.setState({addEmployee: false, editEmployee: null});

        if(this.state.addEmployee) {
            API.addForm76Employee(
                (apiCall: API_CALL) => {
                    this.setState({loading: isLoading(apiCall)});

                    if (isError(apiCall)) showErrorsInToast(apiCall, 'Грешка', translateError);

                    if (isSuccess(apiCall)) {
                        this.loadReport()
                    }
                }, d
            );
        } else {
            API.updateForm76Employee(
                (apiCall: API_CALL) => {
                    this.setState({loading: isLoading(apiCall)});

                    if (isError(apiCall)) showErrorsInToast(apiCall, 'Грешка', translateError);

                    if (isSuccess(apiCall)) {
                        this.loadReport()
                    }
                }, d
            );
        }
    }


    render() {
        return (
            <>
                <div className="card-body">
                    <div className="row justify-content-center">
                        <div className="col-8">


                            <div className={"w-100 overflow-auto"}>
                                <table className={"table table-bordered w-100 "} style={{opacity: (this.state.loading ? 0.3 : 1)}}>
                                    <thead>
                                    <tr>
                                        <th>Име на служителя</th>
                                        <th>Отдел</th>
                                        <th className={"text-right"}>Ставка</th>
                                        <th className={"w-100px text-right"}></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.employees.map(
                                            d =>
                                                <tr>
                                                    <td>{d.name}</td>
                                                    <td>{d.division.name}</td>
                                                    <td className={"text-right"}>{d.rate}</td>
                                                    <td>
                                                        <button type={"button"} className={"btn btn-secondary btn-sm"} onClick={() => {this.editEmployee(d);}}>
                                                            <FontAwesomeIcon icon={"pen"}/>
                                                        </button>
                                                        &nbsp;
                                                        <button type={"button"} className={"btn btn-secondary btn-sm"} onClick={() => {this.deleteEmployee(d)}}>
                                                            <FontAwesomeIcon icon={"trash-alt"}/>
                                                        </button>
                                                    </td>
                                                </tr>
                                        )
                                    }
                                    </tbody>
                                </table>
                            </div>

                        </div>

                    </div>

                </div>

                <div className="card-footer">
                    <button type={"button"} className={"btn btn-primary"}  onClick={() => {this.setState({addEmployee: true})}}>Добави</button>
                </div>

                {
                    (this.state.editEmployee || this.state.addEmployee) &&
                    <Form76EmployeeEditModal
    d={this.state.editEmployee}
    onSave={this.saveEmployee}
    onClose={() => this.setState({editEmployee: null, addEmployee: false})} />
                }

                {
                    this.state.deleteEmployee &&
                        <ConfirmModal
                            title={"Внимание"}
                            message={"Моля, потвърдете изтриването на служителя."}
                            buttons={["Изтрий", "Откажи"]}
                            primaryBtn={"Откажи"}
                            onClose={() => this.setState({deleteEmployee: null})}
                            onButtonClick={(btn) => this.doDeleteEmployee(btn)}
                            ></ConfirmModal>
                }
            </>
        )
    }
}
